<template lang="pug">
  mixin loyaltyID
    tr(v-if="['shell_app','shell_dynamicqr','shell_bonuslink'].includes(loyaltyDetails.source)")
      td(colspan=3).font-weight-bold {{ trans('receipt.shell_go_plus_id') }}: {{ formatLoyaltyId(loyaltyDetails.loyalty_id) }}
    
    tr(v-if="loyaltyDetails.source == 'shell_mobilenumber' ")
      td(colspan=3).font-weight-bold {{ trans('receipt.shell_go_plus_mobile') }}: {{ formatLoyaltyId(loyaltyDetails.loyalty_id) }}

  mixin loyaltyOnline
    +loyaltyID

    tr
      td(colspan=3 style="line-height: 2")
        p(v-html="formattedMessage(trans('receipt.loyalty_available'))")
  
  mixin loyaltyOffline
    +loyaltyID

    tr
      td(colspan=3)
        p(v-html="formattedMessage(trans('receipt.loyalty_offline'))")
  
  mixin noLoyalty
    tr
      td(colspan=3)
        p(v-html="formattedMessage(trans('receipt.no_loyalty'))")
  
  div
    .row
        .col-md-12
            small.dark.block.text-center.m-y-sm {{ trans('receipt.loyalty_details') }}
        
        .col-md-12
          .col-md-12.col-flex
              table.m-b-0.text-center
                tbody
                  template(v-if="!hasLoyaltyID")
                    +noLoyalty
                  
                  template(v-else-if="hasLoyaltyID && !hasManualDiscount && isCapillaryOnline")
                    +loyaltyOnline

                  template(v-else)
                    +loyaltyOffline


</template>

<script>
import receiptMixin from '../../mixins/receipt';
import { mapGetters } from 'vuex';
import Unleash from '@js/plugins/unleash';

export default {
    mixins: [receiptMixin],

    computed: {
        ...mapGetters('transactionPostgres', [
            'loyaltyDetails',
            'metaData',
            'hasManualDiscount',
        ]),
        hasReceiptLoyaltyDetailsMask12DisplayLast4() {
            return Unleash.hasFeature(
                'receipt_loyalty_details_mask_12_display_last_4',
            );
        },
        hasReceiptLoyaltyDynamicMasking() {
            return Unleash.hasFeature('receipt_loyalty_dynamic_masking');
        },
        isCapillaryOnline() {
            return this.metaData && !this.metaData.isCapillaryOffline;
        },
        hasLoyaltyID() {
            return (
                this.loyaltyDetails &&
                this.loyaltyDetails.loyalty_id &&
                this.loyaltyDetails.source
            );
        },
    },

    methods: {
        formatLoyaltyId(loyaltyId) {
            if (this.hasReceiptLoyaltyDynamicMasking) {
                return (
                    '*'.repeat(loyaltyId.length - 4) +
                    String(loyaltyId.slice(-4))
                );
            }

            if (this.hasReceiptLoyaltyDetailsMask12DisplayLast4) {
                return '*'.repeat(12) + String(loyaltyId.slice(-4));
            }

            return '*'.repeat(11) + String(loyaltyId.split('=')[0]).slice(-4);
        },
        formattedMessage(message = '') {
            return message.replace(/\n/g, '<br>');
        },
    },
};
</script>

<style lang="scss" scoped>
table {
    width: 100%;
}

table tr td {
    vertical-align: top !important;
}

.col-flex {
    display: flex;
    border: 2px solid #000;
    padding: 10px;
    border-radius: 10px;
}
</style>
